import "./PublicItineraryDetails.scss";
import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import BlankAvatar from '../../../assets/images/blank-avatar.png';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { publicDetailServiceApi } from '../../../services/CmsService';
import { imageUrlProfile } from '../../../services/CommonUrl';
import moment from 'moment';
import { useAuth } from "../../../contexts/AuthProvider";
import { ItineraryPreviewPlaceholder } from "../../../components/skeleton-placeholder";
import ItineraryListComponent from "../../../components/itinerary-component";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PdfDocument from "../../../components/pdf-view";
import { NoDataFound } from "../../../components/no-data-found";

const ptiItemSliderOptions = {
    loop: false,
    autoplay: false,
    margin: 10,
    responsiveClass: true,
    mouseDrag: false,
    touchDrag: true,
    navText: ['<i class="bi bi-arrow-left-short"></i>', '<i class="bi bi-arrow-right-short"></i>'],
    responsive: {
        0: {
            items: 1,
            nav: false,
            dots: true
        },
        480: {
            items: 2,
            nav: false,
            dots: true
        },
        768: {
            items: 3,
            nav: false,
            dots: true
        },
        1024: {
            items: 3,
            nav: true,
            dots: false,
            margin: 16
        }
    }
}

const PublicItineraryDetails = () => {
    const { authed, currencyData } = useAuth();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [itineraryDetailsData, setItineraryDetailsData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const publicItinerayDetails = async () => {
        setIsLoading(true);
        const Obj = {
            itineraryId: searchParams.get("itineraryId"),
            newCurrency: currencyData?.currency
        }
        await publicDetailServiceApi(Obj, async (res) => {
            setIsLoading(false);
            // console.log("publicDetailServiceApi response: ", res);
            if (res.status === 200) {
                if (res?.data?.success) {
                    setItineraryDetailsData(res.data.data);
                }
            } else {
                console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
                setItineraryDetailsData(null);
            }
        });
    }


    useEffect(() => {
        publicItinerayDetails();
    }, []);

    return (
        <>
            <section className="inner-title-block inner-mrt-80">
                <div className="container-lg text-center">
                    <h1>Overview</h1>
                </div>
            </section>
            <section className="accomadation-details-wrapper padd-top-70 padd-bottom-70">
                <div className="container-lg">
                    {isLoading ? (
                        <ItineraryPreviewPlaceholder />
                    ) : (
                        <>
                            {itineraryDetailsData ? (
                                <>
                                    <div className="d-flex justify-content-between align-items-start">
                                        <div className="flex-grow-1">
                                            <h4 className="d-col-title mb-2">{itineraryDetailsData?.tour_name}</h4>
                                            {itineraryDetailsData?.estimated_Cost ? <p className="txt-cost"> Estimated cost: {currencyData?.currency} {Math.floor(itineraryDetailsData?.estimated_Cost)}</p> : null}
                                        </div>
                                        {authed?.isAuth ? (
                                            <PDFDownloadLink className="btn btn-primary-color text-nowrap ms-3" document={<PdfDocument itineraryData={itineraryDetailsData} authed={authed} currency={currencyData?.currency} />} fileName={"Itinerary" + new Date().getTime() + ".pdf"}>
                                                {({ blob, url, loading, error }) => {
                                                    return (
                                                        <>
                                                            <span className="d-none d-md-block"> Export to PDF</span>
                                                            <i className="d-block d-md-none bi bi-file-earmark-arrow-down-fill"></i>
                                                        </>
                                                    )
                                                }}
                                            </PDFDownloadLink>
                                        ) : (
                                            <Link to="/signin" className="btn btn-primary-color text-nowrap ms-3">
                                                <span className="d-none d-md-block"> Export to PDF</span>
                                                <i className="d-block d-md-none bi bi-file-earmark-arrow-down-fill"></i>
                                            </Link>
                                        )}
                                    </div>
                                    {itineraryDetailsData && itineraryDetailsData?.destinationCityDetails?.length > 0 &&
                                        itineraryDetailsData?.destinationCityDetails?.map((destinationitem, i) => {
                                            return (
                                                <>
                                                    <div className="mt-3">
                                                        <h4 className="d-nav-tabs-title mb-3">Destination City  -  <b>{destinationitem?.destination_city?.city}</b></h4>
                                                        {destinationitem?.itineraryDatys?.length > 0 &&
                                                            <OwlCarousel {...ptiItemSliderOptions} className="owl-carousel owl-theme customItinaray-owl-theme">
                                                                {destinationitem?.itineraryDatys?.map((daysitem, d) => {
                                                                    return (
                                                                        <div className="item" key={daysitem._id}>
                                                                            <ItineraryListComponent
                                                                                key={daysitem._id}
                                                                                destinationIndex={i}
                                                                                daysData={daysitem}
                                                                                itineraryData={itineraryDetailsData}
                                                                            />
                                                                        </div>
                                                                    )
                                                                })}
                                                            </OwlCarousel>}
                                                    </div>
                                                </>
                                            )
                                        })}
                                    {itineraryDetailsData?.commentData?.length > 0 && (
                                        <>
                                            <hr className="mt-3 mb-3" />
                                            <div className="dt-comments-block">
                                                <h4 className="d-nav-tabs-title">Comments</h4>
                                                {itineraryDetailsData?.commentData?.length === 0 ? (
                                                    <p className="mt-2">No comments found.</p>
                                                ) : (
                                                    itineraryDetailsData?.commentData?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))?.map((commentItem, i) => {
                                                        return (
                                                            <>
                                                                <div key={i} className="dt-comment-item">
                                                                    <div className="dt-comment-item-img">
                                                                        {commentItem?.userId?.profileImage === undefined || commentItem?.userId?.profileImage === "" || commentItem?.userId?.profileImage === null ? <img src={`${BlankAvatar}`} alt="No avatar" /> : <img src={imageUrlProfile + commentItem?.userId.profileImage} alt={commentItem?.userId?.name} />}
                                                                    </div>
                                                                    <div className="testimonial-content">
                                                                        <h5>{commentItem?.userId?.name}</h5>
                                                                        <p>{commentItem?.comment}</p>
                                                                        <p className="review-text">Posted on {moment(commentItem?.createdAt).format("DD MMM YY")}</p>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )
                                                    }
                                                    ))}
                                            </div>
                                        </>
                                    )}
                                </>
                            ) : (
                                <NoDataFound text="No data found" />
                            )}
                        </>
                    )}
                </div>
            </section>
        </>
    );
}

export default PublicItineraryDetails;
